import moment from 'moment';
import React from 'react';
import { useChannelIOApi } from 'react-channel-plugin';
import { useLocation } from 'react-router-dom';
import SidebarExpire from '../../Components/SidebarExpire/SidebarExpire';
import { Button } from '../../Components/StyledComponents';
import './ExpirePage.scss';

const ExpirePage = () => {
    const { showMessenger } = useChannelIOApi();//채널톡 오픈
    const {state} = useLocation();
    const { expiry } = state;

    return (
        <div className='expire'>
            <p className='expire-text'>시럽프렌즈 이용기간이 만료되었습니다</p>
            <p className='expire-title' style={{ marginTop : 4 }}>{moment(expiry).format('YYYY-MM-DD')}일 까지</p>
            
            <div className='row' style={{ marginTop : 24 }}>
                <p className='expire-text'>시럽프렌즈를 사랑해주신 사장님께</p>
                <p className='expire-title'>&nbsp;{parseInt(moment.duration(moment(new Date()).utc().diff(moment(expiry),'days')).asDays())}일&nbsp;</p>
                <p className='expire-text'>의 이용기간을 추가로 제공해드렸어요!</p>
            </div>
            <p className='expire-req-text'>기간 연장을 원하시면 아래 버튼을 눌러주세요! 언제든 다시 만날 수 있어요</p>
            <div className='row'>
                <Button variant='sub' style={{ width : 130, marginTop : 32, marginRight : 16 }} onClick={() => window.open('https://syrupfriends.notion.site/8b2611cfd18f464098b31e719df54ad2?p=4350f3dd9ca546bc97ddb36edce3b9bd&pm=s', '_blank')}>
                    연장방법 확인하기
                </Button>
                <Button variant='main' style={{ width : 114, marginTop : 32 }} onClick={showMessenger}>
                    문의하기
                </Button>
            </div>
        </div>
    )
}

export default ExpirePage;